import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_staging/69f93bbaf6558f001471dc75/elearnsmk5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f93bbaf6558f001471dc75/elearnsmk5/src/app/components/TeacherLoginForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f93bbaf6558f001471dc75/elearnsmk5/src/components/ui/AppLogo.tsx");
